// Общие скрипты для всего сайта
// FontAwesome теперь подключается через CSS/Sass

console.log('Main bundle loaded');
